// extracted by mini-css-extract-plugin
export default {"button__back":"BackButton_button__back__VobI5","icon":"BackButton_icon__xB5ov"};